/*
 * Opens the ServiceTitan scheduler popup from:
 *  - any element with [data-scheduler-open]
 *  - any same-site link to the configured schedule page
 *
 * If the ServiceTitan script hasn't loaded (blocked, outage), links fall
 * through to the schedule page as normal.
 */
(function () {
  const config = window.serviceTitanScheduler || {};

  function normalizePath(path) {
    return path.replace(/\/+$/, '').toLowerCase();
  }

  function isSchedulePageLink(link) {
    if (!config.pagePath || !link.href) return false;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.hash) return false;

    // endsWith covers locale-prefixed URLs, e.g. /es/pages/schedule-online
    return normalizePath(url.pathname).endsWith(normalizePath(config.pagePath));
  }

  function openScheduler() {
    if (!window._scheduler || typeof window._scheduler.show !== 'function') return false;

    window._scheduler.show({ schedulerId: config.schedulerId });
    return true;
  }

  document.addEventListener('click', (event) => {
    // Let modified clicks (new tab/window) behave normally
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const trigger = event.target.closest('[data-scheduler-open], a[href]');
    if (!trigger) return;
    if (!trigger.hasAttribute('data-scheduler-open') && !isSchedulePageLink(trigger)) return;

    if (openScheduler()) {
      event.preventDefault();
    } else if (!trigger.href) {
      console.warn('ServiceTitan scheduler is not available.');
    }
  });
})();
